import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--events--refund-requests"
export default class extends Controller {
  static targets = ["sbpsForm"];

  connect() {
    this.observer = new MutationObserver(this.sbpsFormMutated.bind(this));
    this.observer.observe(this.element, { childList: true, subtree: true });
  }

  disconnect() {
    this.observer.disconnect();
    delete this.observer;
  }

  sbpsFormMutated() {
    if (this.hasSbpsFormTarget) {
      this.sbpsFormTarget.submit();
      this.observer.disconnect();
    }
  }
}
